import React, { useState } from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import HeaderSidebar from './HeaderSidebar';
import DocumentAlertsPopup from './DocumentAlertsPopup';

const Layout = ({ children }) => {
  const [isNavbar, setIsNavbar] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <HeaderSidebar knowIsNavbar={setIsNavbar} knowSidebarOpen={setSidebarOpen} />
      <Box sx={{ 
        flexGrow: 1,
        minHeight: '100vh',
        backgroundColor: '#f1f5f9',
        overflow: 'hidden',
        marginLeft: { xs: 0, md: sidebarOpen ? '280px' : '80px' },
        transition: 'margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
      }}>
        {children}
      </Box>
      {/* Popup alertes (documents, maintenance, etc.) - fixé en bas à droite */}
      <DocumentAlertsPopup />
    </Box>
  );
};

export default Layout;
